(function() {
    angular
        .module("app")
        .controller("BroadcastMessageWarningModalController", BroadcastMessageWarningModalController)

    BroadcastMessageWarningModalController.$inject = [
        "$state",
        "$scope",
        "$uibModalInstance",
        "messageBoards",
        "totalQuantitySelected",
        "maxMessageBoardsForAction"
    ]

    function BroadcastMessageWarningModalController(
        $state,
        $scope,
        $uibModalInstance,
        messageBoards,
        totalQuantitySelected,
        maxMessageBoardsForAction
    ){
        "use strict"


        $scope.messageBoards             = messageBoards
        $scope.totalQuantitySelected     = totalQuantitySelected
        $scope.maxMessageBoardsForAction = maxMessageBoardsForAction

        $scope.ok = function() {
            $uibModalInstance.close()
        }

        $scope.cancel = function() {
            $uibModalInstance.dismiss("cancel")
            $state.go("devices")
        }
    }
})()
